import {
  Typenames,
  VxlPageSectionVerticalStackContainer,
  VxlPageSectionVerticalStackContainerChildren,
} from '@varo/graphql-schema-types';
import leadingTrailingTextAccessoriesRowComponent from 'features/borrowingPower/BorrowingPowerScreen/adapters/leadingTrailingTextAccessoriesRowComponent';
import progressBarComponent from 'features/borrowingPower/BorrowingPowerScreen/adapters/progressBarComponent';
import separatedVerticalStackContainer from 'features/borrowingPower/BorrowingPowerScreen/adapters/separatedVerticalStackContainer';
import buttonComponent from 'shared/legacySDUIAdapters/buttonComponent';
import fullWidthTextComponent from 'shared/legacySDUIAdapters/fullWidthTextComponent';
import { VXLNode } from 'shared/renderer/types';
import { isNotNil } from 'shared/utils/isNotNil/isNotNil';

import { BorrowingPowerDependencies } from './types';

export const pageSectionTile = (
  container: VxlPageSectionVerticalStackContainer,
  dependencies: BorrowingPowerDependencies,
): VXLNode[] => {
  return container.content
    .map((child: VxlPageSectionVerticalStackContainerChildren) => {
      if (child.__typename === Typenames.ProgressBarComponent) {
        return progressBarComponent(child);
      } else if (
        child.__typename ===
        Typenames.LeadingTrailingTextAccessoriesRowComponent
      ) {
        return leadingTrailingTextAccessoriesRowComponent(child, dependencies);
      } else if (child.__typename === Typenames.FullWidthTextComponent) {
        return fullWidthTextComponent(child);
      } else if (child.__typename === Typenames.ButtonComponent) {
        return buttonComponent(child, dependencies);
      } else if (
        child.__typename === Typenames.VXLSeparatedVerticalStackContainer
      ) {
        return separatedVerticalStackContainer(child, dependencies);
      }

      return null;
    })
    .filter(isNotNil);
};
